const ColdStoreList = () => import('Views/coldStore/coldStore-list');
const ColdStoreAddEdit = () => import('Views/coldStore/coldStore-addEdit');
const ColdStoreDetail = () => import('Views/coldStore/coldStore-detail');

export default[
  { path: '/coldStore-list', component: ColdStoreList },
  { path: '/coldStore-add', component: ColdStoreAddEdit },
  { path: '/coldStore-edit/:id', component: ColdStoreAddEdit },
  { path: '/coldStore-detail/:id', component: ColdStoreDetail },
];



// WEBPACK FOOTER //
// ./src/router/coldStore.js